import axios from 'axios';

export async function bulkCreate(filters: Record<string, unknown>): Promise<{
  session_url: string;
}> {
  return axios.post(route('api.bulkinator.financial-aid.store'), filters).then((res) => res.data);
}
